var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lz-field"},[_c('label',{staticClass:"lz-field-label"},[_vm._v("Type")]),_c('b-form-select',{attrs:{"options":_vm.holidayTypeOptions,"size":"sm"},on:{"change":_vm.typeChanged},model:{value:(_vm.selectedType),callback:function ($$v) {_vm.selectedType=$$v},expression:"selectedType"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }